import { gql } from '@apollo/client';
import { mutate } from '../apollo/ApolloClient';

export interface JobResponse {
  enqueueJob: Job;
}

export interface Job {
  id: number;
  status: string;
  createdAt: string;
  startedAt: string;
  completedAt: string;
  results: Record<string, unknown> | null;
  options: JobOptions;
  type: string;
  rating: number | null;
  parentId: number | null;
}

export interface EnqueueJobRequest {
  type: string;
  options: JobOptions;
  parentJobId?: number;
}

interface JobOptions {
  startTime: string;
  endTime: string;
  // Used in SimilarityRanking
  primarySelectors?: string;
  secondarySelectors?: string[];
  // Used in RelevanceRanking
  selectors?: string[];
  excludeSelectors?: Record<string, string>[];
}

const ENQUEUE_JOB = gql`
  mutation enqueueJob($type: String!, $options: Map!, $parentJobId: Int32) {
    enqueueJob(type: $type, options: $options, parentJobId: $parentJobId) {
      id
      status
      createdAt
      startedAt
      completedAt
      results
      options
      type
      rating
      parentId
    }
  }
`;

export const submitJob = async (enqueueJobRequest: EnqueueJobRequest): Promise<JobResponse | null | undefined> => {
  const data = await mutate<JobResponse, EnqueueJobRequest>({
    mutation: ENQUEUE_JOB,
    variables: enqueueJobRequest,
  });
  return data;
};
